import { render, staticRenderFns } from "./GuestScreenshots2.vue?vue&type=template&id=37c95f7c&scoped=true&"
import script from "./GuestScreenshots2.vue?vue&type=script&lang=js&"
export * from "./GuestScreenshots2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c95f7c",
  null
  
)

export default component.exports